import { MouseEvent, useCallback } from 'react';
import { Typography, useTheme } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { NodeProps } from 'types.ts';
import { NodeCard } from 'views/flow/canvas/nodes/CustomNode.styles';
import useDialog from 'hooks/useDialog.tsx';
import ConfirmationDialog from 'components/dialog/ConfirmationDialog.tsx';
import { RemoveElementBtn } from '../common/RemoveElementBtn';
import { useReactFlow } from 'reactflow';

export default function FallbackNode({ id }: NodeProps) {
  const reactFlow = useReactFlow();
  const [showConfirmationDialog, StepRemovalConfirmationDialog] = useDialog(ConfirmationDialog);
  const theme = useTheme();

  const onRemoveButtonClick = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();
      showConfirmationDialog();
    },
    [showConfirmationDialog],
  );

  const handleStepRemoval = useCallback(() => {
    reactFlow.setNodes((nodes) => nodes.filter((n) => n.id != id));
  }, [id, reactFlow]);

  return (
    <div className="flex flex-col items-center justify-center">
      <NodeCard className="relative overflow-visible" elevation={0} color="#E4002B">
        <DeleteForeverIcon />
        <RemoveElementBtn onClick={onRemoveButtonClick} className="absolute -top-2 -right-2" />
      </NodeCard>
      <Typography color={theme.palette.text.primary}>Type removed</Typography>
      <StepRemovalConfirmationDialog
        title="Remove step"
        onConfirm={handleStepRemoval}
        buttonsSettings={{ confirmText: 'Remove', confirmColor: 'error' }}
      >
        <Typography>Are you sure you want to remove this step?</Typography>
      </StepRemovalConfirmationDialog>
    </div>
  );
}
